var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 473,
    viewBox: "0 0 286 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.072 423.37C133.323 426.111 136.562 449.015 136.314 451.258C136.064 453.501 129.343 469.932 131.833 470.928C134.323 471.924 154.742 473.916 158.227 471.426C161.713 468.937 171.424 452.003 172.667 446.279C173.91 440.554 173.914 407.934 173.914 407.934L134.076 423.37H134.072Z",
    fill: "#254EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.667 446.279C173.914 440.551 173.914 407.934 173.914 407.934L134.076 423.37C133.671 424.856 134.439 432.284 135.188 439.124C147.726 442.629 163.379 447.11 165.202 450.76C166.116 452.587 166.378 456.091 166.299 460.052C169.313 454.796 172.05 449.139 172.671 446.279H172.667Z",
    fill: "#1939B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.207 447.866C168.931 446.339 160.983 443.553 148.763 445.036C144.315 445.575 140.013 446.59 136.105 447.78C136.273 449.543 136.363 450.813 136.311 451.258C148.504 447.993 166.213 451.198 170.473 452.056C171.2 450.491 171.799 449.057 172.203 447.862L172.207 447.866Z",
    fill: "#142C4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.857 419.274C224.677 422.082 219.926 446.631 220.151 449.049C220.375 451.479 228.256 469.581 225.063 470.711C221.888 471.838 196.815 474.039 192.828 471.321C188.893 468.641 178.863 450.914 177.849 445.047C176.845 439.248 178.953 406.886 178.953 406.886L223.857 419.274V419.274Z",
    fill: "#254EDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.849 445.047C176.845 439.248 178.953 406.886 178.953 406.886L223.857 419.274C224.303 420.798 223.12 428.649 221.97 435.949C206.718 440.255 188.268 445.571 185.973 449.431C184.824 451.367 184.307 455.039 184.15 459.21C181.057 453.755 178.354 447.963 177.849 445.043V445.047Z",
    fill: "#1939B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.257 446.664C182.019 444.976 191.207 441.786 205.37 442.842C210.649 443.235 215.8 444.148 220.532 445.279C220.263 447.192 220.106 448.57 220.151 449.049C205.538 445.964 184.786 449.925 179.919 450.94C179.204 449.337 178.631 447.877 178.253 446.661L178.257 446.664Z",
    fill: "#142C4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.185 423.026C84.1963 424.542 82.2794 436.59 91.4294 439.304C100.579 442.022 104.402 438.593 104.402 438.593C104.402 438.593 113.896 443.886 117.603 441.198C121.309 438.51 122.013 434.085 122.013 434.085C122.013 434.085 130.658 435.208 132.455 428.686C134.248 422.165 126 424.886 125.637 425.583C125.274 426.283 128.553 410.416 123.054 408.533C117.554 406.65 84.1888 423.026 84.1888 423.026H84.185Z",
    fill: "#254EDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.8 363.075C84.6381 364.708 77.3189 374.254 75.6117 377.077C73.9007 379.9 70.6361 421.038 81.1076 431.273C91.5829 441.509 120.441 429.675 127.269 415.291C134.098 400.903 131.399 371.911 125.607 365.516C119.819 359.122 102.8 363.079 102.8 363.079V363.075Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2152 329.826C84.4696 335.592 80.7107 371.959 84.4958 375.123C88.2771 378.287 112.313 377.777 115.963 370.675C119.613 363.573 118.003 313.48 93.2152 329.826V329.826Z",
    fill: "#254EDB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M125.611 365.516C119.819 359.122 102.803 363.079 102.803 363.079C84.6418 364.711 77.3226 374.258 75.6154 377.081C80.1754 385.026 103.582 381.54 103.582 381.54C103.582 381.54 113.054 413.606 104.458 432.909C114.229 429.551 123.724 422.767 127.273 415.295C134.102 400.907 131.403 371.915 125.611 365.52V365.516Z",
    fill: "url(#paint0_radial_15920_56237)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.885 312.196C120.119 319.497 101.837 327.876 99.9618 333.207C98.0861 338.538 120.373 430.865 133.031 435.665C145.689 440.465 240.675 420.487 245.137 417.021C249.6 413.554 254.096 317.34 243.445 310.845C232.798 304.349 198.317 305.832 161.885 312.196V312.196Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M243.445 310.845C232.797 304.349 198.316 305.832 161.885 312.196C120.115 319.497 101.837 327.876 99.9616 333.207C104.016 355.393 235.268 333.645 243.445 310.845Z",
    fill: "#15104E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.21 315.124C214.861 311.324 190.72 312.747 165.142 317.172C135.82 322.249 122.908 327.628 121.515 330.904C124.02 344.364 216.145 329.141 222.21 315.124Z",
    fill: "#183059"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.207 363.375C219.286 368.291 209.705 372.091 199.881 374.786C198.489 375.168 197.092 375.527 195.685 375.849C195.31 375.935 194.936 376.018 194.558 376.096C194.292 376.153 193.974 376.213 194.46 376.119C193.962 376.213 193.341 376.534 193.292 377.126C193.083 379.739 192.862 382.356 192.637 384.969C192.165 390.42 191.675 395.872 191.132 401.315C190.653 406.122 190.196 410.948 189.444 415.725C189.335 416.407 189.226 417.084 189.077 417.758C189.047 417.885 189.013 418.013 188.983 418.14C188.901 418.166 188.833 418.189 188.803 418.196C188.365 418.297 187.931 418.402 187.493 418.499C186.138 418.81 184.779 419.106 183.416 419.39C180.713 419.952 178.002 420.461 175.281 420.925C166.153 422.479 156.928 423.565 147.681 424.063C144.858 424.212 142.028 424.321 139.201 424.269C138.737 424.261 138.276 424.246 137.816 424.224C137.67 424.216 137.486 424.201 137.468 424.201C137.344 424.19 137.217 424.183 137.093 424.168C136.97 424.153 136.835 424.123 136.7 424.096C136.666 424.055 136.633 424.014 136.607 423.977C136.461 423.756 136.322 423.527 136.191 423.303C135.813 422.655 135.461 421.996 135.113 421.33C134.068 419.334 133.245 417.62 132.245 415.534C129.778 410.386 127.4 405.194 125.042 399.997C123.305 396.171 121.582 392.337 119.875 388.496C119.718 388.144 119.568 387.792 119.407 387.444C118.891 386.317 117.363 386.085 116.307 385.576C114.136 384.531 112.11 383.199 110.224 381.697C110.594 383.034 110.976 384.374 111.358 385.714C113.219 386.924 115.18 387.946 117.195 388.698C120.16 395.389 123.17 402.06 126.244 408.702C128.284 413.116 130.336 417.533 132.548 421.869C133.158 423.063 133.754 424.302 134.51 425.414C135.105 426.29 135.775 426.586 136.809 426.683C141.96 427.166 147.28 426.695 152.421 426.305C161.63 425.609 170.807 424.388 179.878 422.666C182.371 422.191 184.861 421.682 187.34 421.128C187.995 420.982 188.65 420.832 189.305 420.678C189.732 420.577 190.23 420.54 190.608 420.289C190.844 420.132 191.02 419.907 191.151 419.656C191.634 418.739 191.735 417.533 191.896 416.53C192.6 412.187 193.023 407.796 193.468 403.423C194.314 395.1 195.048 386.766 195.726 378.429C201.132 377.306 206.456 375.584 211.618 373.678C223.539 369.283 235.044 363.292 244.927 355.258C246.657 353.85 248.331 352.375 249.944 350.844C249.926 349.684 249.896 348.534 249.866 347.392C243.516 353.753 236.066 359.039 228.207 363.371V363.375ZM189.346 418.039C189.395 418.02 189.44 418.009 189.473 418.039C189.455 418.028 189.406 418.031 189.346 418.039Z",
    fill: "#15104E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M243.445 310.845C232.797 304.349 198.316 305.832 161.885 312.196C120.115 319.497 101.837 327.876 99.9616 333.207C99.0069 335.917 104.297 361.102 111.392 385.845C141.874 387.111 175.996 382.39 207.912 353.652C203.382 397.83 198.766 422.857 165.528 433.913C197.871 429.225 242.127 419.364 245.141 417.024C249.604 413.557 254.1 317.344 243.449 310.849L243.445 310.845Z",
    fill: "url(#paint1_radial_15920_56237)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.545 397.958C189.756 385.747 189.756 365.948 177.545 353.737C165.333 341.526 145.535 341.526 133.324 353.737C121.113 365.948 121.113 385.747 133.324 397.958C145.535 410.169 165.333 410.169 177.545 397.958Z",
    fill: "#15104E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.015 393.443C186.5 382.958 186.5 365.96 176.015 355.475C165.531 344.991 148.532 344.991 138.048 355.475C127.563 365.96 127.563 382.958 138.048 393.443C148.532 403.927 165.531 403.927 176.015 393.443Z",
    fill: "#1939B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.251 389.678C180.656 381.273 180.656 367.645 172.251 359.24C163.845 350.834 150.217 350.834 141.812 359.24C133.407 367.645 133.407 381.273 141.812 389.678C150.217 398.084 163.845 398.084 172.251 389.678Z",
    fill: "#254EDB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.744 357.355C130.98 363.76 135.79 372.506 143.428 366.542C151.065 360.578 148.643 350.848 139.744 357.355Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.851 396.22L159.199 368.54L159.159 368.351L144.328 371.484L142.855 364.508L166.735 359.464L168.209 366.44L160.837 394.321L151.851 396.22Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M227.582 411.42C227.833 412.914 227.833 425.115 237.294 426.358C246.754 427.604 249.993 423.617 249.993 423.617C249.993 423.617 260.202 427.354 263.437 424.115C266.675 420.877 266.675 416.395 266.675 416.395C266.675 416.395 275.391 416.144 276.136 409.424C276.885 402.7 269.165 406.684 268.914 407.433C268.663 408.181 269.412 391.993 263.684 390.997C257.956 390.001 227.578 411.416 227.578 411.416L227.582 411.42Z",
    fill: "#254EDB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236.545 349.287C218.866 353.753 213.138 364.333 211.895 367.388C210.649 370.443 213.887 411.584 225.838 420.046C237.788 428.507 264.433 412.288 268.914 397.006C273.396 381.727 266.174 353.517 259.454 348.107C252.73 342.701 236.545 349.283 236.545 349.283V349.287Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M258.956 355.644C258.956 355.644 265.29 383.988 262.737 407.406C265.672 404.1 267.881 400.529 268.914 397.01C273.396 381.731 266.174 353.521 259.454 348.111C252.73 342.705 236.545 349.287 236.545 349.287C218.866 353.753 213.138 364.333 211.895 367.388C211.716 367.826 211.63 369.054 211.648 370.855C215.789 372.45 222.603 372.263 231.566 370.084C259.203 363.36 258.956 355.644 258.956 355.644V355.644Z",
    fill: "url(#paint2_radial_15920_56237)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M221.854 317.958C214.123 325.027 216.126 361.533 220.36 364.064C224.595 366.595 248.248 362.312 250.738 354.727C253.228 347.141 243.767 297.921 221.854 317.958V317.958Z",
    fill: "#254EDB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6488 370.23C32.6733 375.101 -10.8041 267.828 23.5982 200.592C58.0005 133.356 189.657 98.1901 247.316 155.183C304.979 212.175 282.306 310.025 273.864 317.539C265.421 325.053 129.373 361.237 66.6488 370.23V370.23Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M278.042 206.811C270.094 280.617 169.346 341.23 85.4242 353.375C66.8023 356.071 51.6808 355.786 39.401 353.487C48.0755 365 57.6935 371.514 66.6488 370.23C129.377 361.237 265.421 325.053 273.864 317.539C280.063 312.02 293.934 257.802 278.042 206.814V206.811Z",
    fill: "url(#paint3_radial_15920_56237)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.508 342.911C85.4729 353.835 33.643 333.869 32.0219 262.766C30.3971 191.663 110.853 160.963 173.337 166.721C235.822 172.479 251.614 240.749 246.088 272.931C240.562 305.113 200.143 330.654 139.512 342.911H139.508Z",
    fill: "#15104E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M143.184 347.302C90.7442 357.849 40.2247 337.449 38.1169 266.173C36.0128 194.898 113.982 164.722 174.756 170.963C235.53 177.2 251.386 245.743 246.253 277.959C241.12 310.175 202.023 335.472 143.184 347.306V347.302Z",
    fill: "#254EDB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6 204.89C218.155 187.406 200.484 173.603 174.76 170.963C127.206 166.081 69.1235 183.498 47.1133 225.455C59.176 214.317 76.9519 204.564 102.537 197.485C168.639 179.192 207.541 190.12 229.6 204.89Z",
    fill: "#1939B7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.717 156.194C111.919 156.366 111.159 155.793 111.103 154.981C110.31 143.285 105.431 68.3216 110.77 66.7978C116.558 65.1468 134.66 128.538 134.345 129.848C134.031 131.155 125.805 151.581 122.496 153.273C120.085 154.509 115.195 155.662 112.717 156.197V156.194Z",
    fill: "#254EDB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.345 129.844C134.611 128.744 121.781 83.4842 114.282 70.3208C112.279 86.3558 119.875 146.508 122.496 153.27C125.805 151.577 134.031 131.151 134.345 129.844Z",
    fill: "#1939B7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3657 205.148C58.783 214.856 65.1401 226.578 80.8642 216.047C96.5884 205.519 88.6627 193.497 72.3657 205.148Z",
    fill: "white"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2085 272.976C50.8722 287.959 54.7584 325.056 88.5991 311.309C122.44 297.562 106.843 248.652 72.2085 272.976Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M184.303 269.273C164.229 272.815 152.844 243.366 175.314 234.111C197.785 224.856 223.43 233.055 226.073 248.386C228.717 263.721 202.809 262.927 205.452 269.801C208.095 276.675 215.497 283.548 204.659 290.156C193.82 296.764 186.415 291.744 186.415 283.548C186.415 275.353 193.288 267.686 184.299 269.273H184.303Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.226 310.837C123.203 304.724 130.302 285.529 150.122 284.758C169.942 283.986 173.461 301.242 165.913 303.327C158.366 305.412 154.367 296.933 147.22 301.111C140.077 305.289 139.714 315.91 132.226 310.837V310.837Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00440529 70.7963C0.670811 100.552 1.62924 130.301 2.61013 160.046C2.89092 168.511 3.22038 176.916 4.21624 185.332C4.49329 187.664 7.82532 187.784 7.94138 185.332C8.65645 170.48 7.62315 155.553 7.0466 140.709C6.47004 125.835 5.84108 110.96 5.23831 96.086C4.89762 87.6549 4.49703 79.2275 4.09644 70.8C3.96915 68.1831 -0.0592402 68.1494 0.000661436 70.8H0.00440529V70.7963Z",
    fill: "#942B90"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0041 79.7554C19.9218 92.3722 19.8357 104.985 19.7533 117.602C19.6709 130.204 19.2292 142.881 20.2512 155.449C20.4497 157.897 23.8603 157.901 24.0587 155.449C25.0771 142.877 24.639 130.2 24.5567 117.602C24.4743 104.985 24.3882 92.3684 24.3058 79.7554C24.2871 76.9887 20.0229 76.9849 20.0079 79.7554H20.0041Z",
    fill: "#942B90"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3703 2.05912C41.7035 37.7905 41.5799 73.5256 41.4714 109.257C41.4414 119.354 41.4227 129.421 41.7896 139.511C41.8907 142.315 45.9715 142.293 46.1287 139.511C47.1545 121.608 46.9636 103.652 46.8887 85.723C46.8176 67.9173 46.6304 50.1115 46.2935 32.3095C46.1025 22.2235 45.8779 12.1413 45.6271 2.05538C45.5597 -0.677634 41.3441 -0.692609 41.3665 2.05538L41.3703 2.05912Z",
    fill: "#942B90"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9473 76.7678C59.9398 85.7306 59.7901 94.7008 60.1307 103.66C60.2206 106.056 63.766 106.06 63.8559 103.66C64.1966 94.7008 64.0468 85.7306 64.0393 76.7678C64.0393 74.1321 59.9473 74.1284 59.9436 76.7678H59.9473Z",
    fill: "#942B90"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.435 73.7876C153.795 83.7463 154.042 93.7162 154.637 103.664C154.779 106.037 158.396 106.082 158.362 103.664C158.224 93.7012 157.741 83.7425 157.366 73.7876C157.273 71.268 153.345 71.253 153.435 73.7876V73.7876Z",
    fill: "#942B90"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M179.425 21.9877C179.384 35.6003 179.343 49.213 179.301 62.8219C179.26 76.4495 179.182 90.0397 179.792 103.656C179.889 105.869 183.131 105.872 183.232 103.656C183.843 90.0397 183.764 76.4495 183.723 62.8219C183.682 49.2093 183.641 35.5966 183.599 21.9877C183.592 19.2996 179.432 19.2959 179.421 21.9877H179.425Z",
    fill: "#942B90"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15920_56237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.665 401.457) scale(55.3155 55.3155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88AFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8BB1C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#95B7CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A6C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BED3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DCE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_15920_56237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.107 394.486) scale(113.053 113.053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88AFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8BB1C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#95B7CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A6C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BED3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DCE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_15920_56237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.315 392.992) scale(67.7563 67.7563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88AFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8BB1C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#95B7CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A6C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BED3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DCE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_15920_56237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189.611 264.27) rotate(-11.9) scale(112.091 112.091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88AFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8BB1C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#95B7CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A6C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BED3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DCE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.8b8a61706a98c7c9e108c2cda5803aab.svg";
export { ForwardRef as ReactComponent };